import { FC } from "react";
import useModalChat, { ReceivedProps, Props } from "./hook";
import { GlobalModalStyles } from "./styled";
import ModalConfirm from "@lhd/components/Modal/ModalConfirm";
import ChatModalInstance from "./ChatModalInstance";
import { createPortal } from "react-dom";

const ModalChatLayout: FC<Props> = (controller) => {
  const {
    modals,
    confirmCloseChat,
    handleConfirmOk,
    handleConfirmCancel,
    confirmMessage,
  } = controller;

  const content = (
    <>
      <GlobalModalStyles />

      {modals.map((modal, index) => (
        <ChatModalInstance
          key={modal.id}
          modal={modal}
          index={index}
          controller={controller}
        />
      ))}

      <ModalConfirm
        isOpen={confirmCloseChat.isOpen}
        content={confirmMessage}
        onCancel={handleConfirmCancel}
        onOk={handleConfirmOk}
        okText="はい"
        cancelText="いいえ"
        zIndex={1100}
      />
    </>
  );

  return createPortal(content, document.body);
};

const ModalChat: FC<ReceivedProps> = (props) => (
  <ModalChatLayout {...useModalChat(props)} />
);

export default ModalChat;
